import { LicenseInfo } from '@mui/x-license-pro'

LicenseInfo.setLicenseKey(
  '4d1f2fd08b25f007dddc36f364f418e4Tz0xMTk3MTEsRT0xNzkwNTUzNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI='
)
